var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.99c-.29 0-.56-.11-.77-.32l-7.99-8c-.05-.07-.07-.09-.09-.12-.04-.06-.05-.09-.06-.11l-.08-.24c0-.05-.01-.09-.02-.13v-.09l.04-.29.04-.12c.03-.07.04-.1.06-.12.04-.07.06-.09.08-.12 0 0 .01-.02.02-.03s.03-.03.04-.05l.04-.04 7.92-7.92c.41-.41 1.12-.41 1.53 0 .2.2.32.48.32.77s-.11.56-.32.77L6.69 10.9h13.33a1.082 1.082 0 0 1-.11 2.16H6.7l6.15 6.16c.34.44.31 1.06-.08 1.44-.2.2-.48.32-.77.32Z",
    fill: "#2a3349"
  })));
};

export default SvgArrowLeft;